import { render, staticRenderFns } from "./DeMinimis.vue?vue&type=template&id=5c4ba182&"
import script from "./DeMinimis.vue?vue&type=script&lang=js&"
export * from "./DeMinimis.vue?vue&type=script&lang=js&"
import style0 from "./DeMinimis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports